import { DlpProductTradeId } from 'epic/blotters/commonBlotterEpics';
import { DocumentationV3 } from 'epic/common-form/Documentation';
import type { BlotterItemAction } from 'models/blotters/BlotterItemAction';
import type { BlotterType } from 'models/blotters/BlotterType';
import type { IBlotterItem, SelectedBlotterItem } from 'models/IBlotterItem';
import { BackendError } from 'models/NextWorkflowError';

export type BlotterPanelIDByBlotterType<T extends BlotterType> = T extends 'dlpProductTrades'
  ? DlpProductTradeId
  : string;
export interface IBlotterPanelState<Blotter extends BlotterType = BlotterType> {
  id?: BlotterPanelIDByBlotterType<Blotter>;

  item: IBlotterItem | undefined;
  blotterType?: Blotter;
  actions?: BlotterItemAction[];
  documents?: DocumentationV3;
  isFetching: boolean;
  isFetchingFailed: boolean;
  fetchErrorDetails?: BackendError;
  isShowFailedAlert: boolean;
  selected?: SelectedBlotterItem;
}

export type BlotterPanelState<Blotter extends BlotterType = BlotterType> = Readonly<IBlotterPanelState<Blotter>>;

export const initialBlotterPanelState: IBlotterPanelState = {
  id: undefined,
  blotterType: undefined,
  actions: undefined,
  item: undefined,
  documents: undefined,
  isFetching: false,
  isFetchingFailed: false,
  isShowFailedAlert: false,
  selected: undefined,
};
